import React, { useMemo } from 'react';
import { Clock } from 'lucide-react';
import { useProperties } from '../hooks/useProperties';
import { PropertyCategoryView } from '../components/properties/PropertyCategoryView';
import { Counter } from '../components/ui/Counter';

export const ShortRentList: React.FC = () => {
  const { properties, isLoading } = useProperties();

  const shortRentProperties = useMemo(
    () => properties.filter(p => p.status === 'for-short-rent'),
    [properties]
  );

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <div className="container mx-auto px-4 py-4">
        <div className="mb-6 flex items-center justify-between">
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-3">
              <Clock className="h-8 w-8 text-primary-500" />
              <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
                Location courte durée
              </h1>
            </div>
            <Counter 
              count={shortRentProperties.length} 
              label={shortRentProperties.length > 1 ? "biens" : "bien"}
              variant="info"
            />
          </div>
        </div>
        <PropertyCategoryView
          title=""
          properties={shortRentProperties}
          isLoading={isLoading}
        />
      </div>
    </div>
  );
};